module.exports = function(){
    $(function(){
        // $('#loader').fadeIn();
        if(!$('link[data-home-style="core"]').length){
            $('head').append(`
                <link data-home-style="core" rel="stylesheet" href="/assets/parent/css/style.css">
            `);
        }
        if(!$('link[data-home-style="theme"]').length){
            $('head').append(`
                <link data-home-style="theme" rel="stylesheet" href="/assets/parent/css/theme-overrides.css">
            `);
        }
        if(!$('link[data-home-style="rebrand"]').length){
            $('head').append(`
                <link data-home-style="rebrand" rel="stylesheet" href="/assets/css/rebrand.css">
            `);
        }

        setTimeout(()=>{
            $('body').append(`
            <script src="/assets/parent/vendors/jquery/jquery.min.js"></script>
            <script src="/assets/parent/vendors/bootstrap/popper.min.js"></script>
            <script src="/assets/parent/vendors/bootstrap/bootstrap.min.js"></script>
            <script src="/assets/parent/js/plugins.min.js"></script>
            <script src="/assets/parent/js/active.js"></script>
        `);
            // const body = document.getElementsByTagName('body')[0];
            // body.addEventListener('load', ()=>{
            //     $('#loader').fadeOut();
            // })
        }, 1000)


    })
}
